export default __webpack_public_path__ + "static/media/icon-offres.9dff012e.svg";